// extracted by mini-css-extract-plugin
module.exports = {"container":"PDPLink_container___JdNq"};